var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.167 5.833a.833.833 0 0 0-.834.834v9.166a.833.833 0 0 0 .834.834h9.166a.833.833 0 0 0 .834-.834v-5a.833.833 0 0 1 1.666 0v5a2.5 2.5 0 0 1-2.5 2.5H4.167a2.5 2.5 0 0 1-2.5-2.5V6.667a2.5 2.5 0 0 1 2.5-2.5h5a.833.833 0 0 1 0 1.666zm7.5-3.333c0-.46.373-.833.833-.833h5c.46 0 .833.373.833.833v5a.833.833 0 1 1-1.666 0V3.333H12.5a.833.833 0 0 1-.833-.833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.09 1.91a.833.833 0 0 1 0 1.18l-9.167 9.166a.833.833 0 1 1-1.179-1.179l9.167-9.166a.833.833 0 0 1 1.178 0Z"
  })));
};
export default SvgExternalLink;